import { render, staticRenderFns } from "./StaffPopover.vue?vue&type=template&id=7ffb763c&"
import script from "./StaffPopover.vue?vue&type=script&lang=js&"
export * from "./StaffPopover.vue?vue&type=script&lang=js&"
import style0 from "./StaffPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports